<template>
    <div class="validator-score-container">
        <h4>
         Scoring Breakdown:
        </h4>

        <ul class="list-unstyled">
            <li class="d-flex justify-content-between">
                <span class="text-muted small text-uppercase w-50">Type</span>
                <span class="text-muted small text-uppercase w-25">Score</span>
                <span class="text-muted small text-uppercase w-25 text-right">Weighted Score</span>
            </li>
            <li

                v-for="(score, key) in validator.weighted_scores"
                :key="key"
            ><div class="d-flex justify-content-between  mt-2">
                <span class="w-50">{{ formatKey(key) }}:

                </span>
                <span class="w-25"><b-progress
                    :value="validator.scores[key]" max="1" :variant="scoreVariant(validator.scores[key])" show-progress></b-progress></span>
                <span class="w-25 text-right">{{ (score*100).toFixed(2) }}%</span>
            </div>
                <p class="text-muted small w-100">{{ descriptions[key] || ''}}</p>

            </li>
        </ul>
        <div class="score-modifiers" v-if="Object.keys(validator.modifiers).length > 0">
            <h4>Score modifiers</h4>
            <ul class="list-unstyled">
                <li class="d-flex justify-content-between">
                    <span class="text-muted small text-uppercase w-50">Type</span>
                    <span class="text-muted small text-uppercase w-50 text-right">Impact</span>
                </li>
                <li v-for="modifier in Object.keys(validator.modifiers)" :key="modifier" >
                    <div class="d-flex justify-content-between mt-2">
                        <span class="w-50">{{ formatKey(modifier) }}</span>
                        <span class="w-50 text-right"
                              :class="{'text-danger': validator.modifiers[modifier] < 0, 'text-success': validator.modifiers[modifier] > 0}"
                        >{{ (validator.modifiers[modifier]*100).toFixed(0) }}%</span>
                    </div>
                    <p class="text-muted small w-100">{{ descriptions[modifier] || ''}}</p>

                </li>
            </ul>


        </div>
        <p class="text-muted small">Please note our scoring is in beta and criteria are likely to change based on user feedback. Many thanks to ValidatorsApp, Marinade, Jito and Stakeview for supplying additional data to enrich our own.</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // Add any data properties you need
            descriptions: {
                'skippedSlotsPercent': 'When a validators slot is skipped, it processes no transactions. Generally, the lower the skip rate, the better the performance, although it is possible for an earlier leaders performance to cause a later leader to skip.',
                'epochCredits': 'Epoch credits is a measure of how many votes a validator successfully submitted, and directly affects its APY performance and staker returns.',
                'cu': 'Compute units (CU) are a measure of how much processing power a validator spends building a block. A higher performing validator can process more transaction in a slot and get a higher CU, assuming enough network activity',
                'txns': 'How many transactions on average did this validator process in a block? Although this figure also depends on network activity, a higher performing validator will process more transactions on average.',
                'user_txns': 'How many user transactions on average did this validator process in a block? Since user transactions are most important, and demand more processing power than votes this is a good indicator of a validators performance.',
                'rootDistanceScore': 'This is a measure of how far behind the leader the validator is. A low performing validator will struggle to keep up with the leader, and will score poorly here.',
                'voteDistanceScore': '',
                'uptime': 'This compares the validators uptime against the rest of the cluster. As brief downtime may be expected in the event of network upgrades or instability, this is a measure of how stable the validator is versus its peers.',
                'blockTime': 'This compares the validators median block time against the median for their software client (eg Jito, Agave, Frankendancer etc). Validators faster than their client median can score up to 110% to reward performance optimization.',
                'excessive_commission':'This validator has an excessively high commission (over 10%) and thus should be avoided', //danger
                // 'low_commission':'Zero and low commission validators can harm decentralization by concentrating stake and making smaller independent validators unprofitable. This modifier only applies to validators with more than 150k in stake, and operates on a sliding scale from 0-2% commission.',
                'low_software_version':'This validator is running an old version of Solanas software and may be missing out on performance improvements and bug fixes. It can be an indication of a less diligent validator.',
                'low_published_information':'This validator has not provided a name, logo or description. This suggests they are not motivated or serious about their role as a validator.',
                'high_stake_concentration':'This validator already has a large amount of stake, and thus should be avoided to prevent further centralization of stake.', // danger
                'high_data_center_concentration':'This node is in a DC with a large amount of stake. This harms decentralization as in the event of an outage it could adversely affect Solanas performance.', // danger
                'extreme_data_center_concentration':'This node is in a DC with an excessive amount of stake. This harms decentralization as in the event of an outage it could adversely affect Solanas performance.',
                'delinquent':'This validator is currently offline. This may be temporary - check the uptime score above to decide if this validator has long term reliability issues',
                "SLOW_VOTER":'This validator is slow to vote, and may well be "vote lagging", a way of cheating the network to gain a higher APY by slowing down user transactions. If it is unintentional it may be due to poor hardware or connectivity. Either way, this validator should be avoided.',
                "BLACKLIST_COMMISSION_RUG":'This validator has been caught cheating its stakers by changing commission to 100% at the last minute before epoch end. It is stealing from the network and should not be trusted',
                'high_commission':'This validator has a relatively high commission (>7%) compared to the average node', // warning


            }
        };
    },
    props: {
        validator: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatKey(key) {
            key= key.replace(/([a-z])([A-Z])/g, '$1 $2')
            key = key.replace(/_/g, ' ')
            key = key.charAt(0).toUpperCase() + key.slice(1)
            return key
                // .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                // .join(' x ');
        },
        getBadgeType(flag) {
            const dangerFlags = [
                'excessive_commission',
                'high_stake_concentration',
                'extreme_data_center_concentration',
                'admin_warning'
            ];
            if (flag === 'JITO_MEV') return 'bg-success';

            return dangerFlags.includes(flag) ? 'bg-danger' : 'bg-warning';
        },
        scoreVariant(score) {
            if (score < 0.5) return 'danger';
            if (score < 0.75) return 'warning';
            return 'success';
        },
        icon(flag) {
            if(flag === 'JITO_MEV') return 'fas fa-bolt bg-white'
            return 'fas fa-exclamation-triangle bg-white'
        }

    },
    mounted() {
        console.log('ValidatorScore mounted', this.validator)
    }
};
</script>

<style scoped>
.validator-score-container {
    /* Add any desired styles */
}
</style>
